var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { useScript } from '../../hooks/useScript.hook';
import { MainLayout } from '../../components/layouts/MainLayout';
import { Container } from '../../uikit/grid';
import { Spacer } from '../../uikit/misc/Spacer';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { gdprDataSlice } from '../../store/gdprData/gdprData.slice';
var IFRAME_BASE_URL = 'https://comparison.financeads.net/mortgages.php?adspace=38614&loan=250000&duration=25&redemption=0.02&loan_to_value_limit=80&country_iso2=DE';
var IFRAME_SCRIPT_URL = '//facdn.financeads.net/js/financeads/iframe-resizer-modal.min.js';
var FACEBOOK_TRACKING_PARAMS = {
    tracking_type: 'facebook',
    tracking_object_id: '266987448025538',
    tracking_object_name: 'SubmitApplication',
};
var FinanceAdsComparisonPageRaw = function () {
    useScript(IFRAME_SCRIPT_URL);
    var isMarketingCategoryGranted = useSelector(gdprDataSlice.selectors.isMarketingCategoryGranted);
    var currentSearch = typeof window === 'undefined' ? '' : window.location.search;
    var iframeSrc = useMemo(function () {
        if (!isMarketingCategoryGranted || currentSearch === '') {
            return IFRAME_BASE_URL;
        }
        var fbclid = new URLSearchParams(currentSearch).get('fbclid');
        if (fbclid === null || fbclid === '') {
            return IFRAME_BASE_URL;
        }
        var extraParams = new URLSearchParams(__assign({ tracking_id: fbclid }, FACEBOOK_TRACKING_PARAMS));
        return "".concat(IFRAME_BASE_URL, "&").concat(extraParams.toString());
    }, [isMarketingCategoryGranted, currentSearch]);
    var ref = useRef(null);
    var handleIframeLoad = useCallback(function () {
        if (ref.current !== null && typeof window.iFrameResize === 'function') {
            window.iFrameResize(ref.current);
        }
    }, []);
    return (React.createElement(MainLayout, null,
        React.createElement(Container, null,
            React.createElement(Spacer, { size: 2 }),
            React.createElement(ClientOnlyContent, null,
                React.createElement("iframe", { ref: ref, src: iframeSrc, onLoad: handleIframeLoad, scrolling: "no", width: "100%", frameBorder: "0" })),
            React.createElement(Spacer, { size: 2 }))));
};
export var FinanceAdsComparisonPage = connect()(FinanceAdsComparisonPageRaw);
